export const FAQS_WESTFIELD_MEMBERSHIP =
  'https://support.westfield.com.au/hc/en-us/categories/360002581332'
